module.exports = __webpack_public_path__ + "static/media/seriousBleedingContinues.ef191796.mp3";